import { render, staticRenderFns } from "./afterTheTask.vue?vue&type=template&id=cdb4bb32&scoped=true"
import script from "./afterTheTask.vue?vue&type=script&lang=js"
export * from "./afterTheTask.vue?vue&type=script&lang=js"
import style0 from "./afterTheTask.vue?vue&type=style&index=0&id=cdb4bb32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb4bb32",
  null
  
)

export default component.exports